import { BlogPost } from "ExtendiApp"

export const validatePost = (post: BlogPost) => {
  const isValidPost = Boolean(
    post && post.id && post.title && post.date && post.imageUrl
  )
  if (!isValidPost) {
    console.warn("Invalid post", post)
  }

  const isValidPostDate = Boolean(
    post && post.date && new Date(post.date).getTime() > 0
  )

  if (!isValidPostDate) {
    console.warn("Invalid post date", post)
  }

  return isValidPost && isValidPostDate
}
